<section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-panel">
<form>
  <h4 class="pageTitle"> Volunteer experience <a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn" (click)="openModal(addMore)"> <i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add More </a></h4>

  <div class="education_added">
      <ul class="timeline">
          <li *ngFor="let data of allData;let i=index"> 
              <span class="timeline-point-circle fill"></span>
              <div class="el_details"> 
                  <p> <strong class="firstlCaptial">{{data.organization || "N/A"}}</strong> <span class="time">{{data.employementTypeDetails?.name}}                </span>
                      <a href="javascript:void(0);" (click)="edit(data,addMore)" title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                      <a href="javascript:void(0);" (click)="delete(data.id)" title="Delete"><img src="assets/images/ic_delete.svg" class="ht"> </a>

                  </p> 
                  <p class="para3"> {{data.role || "N/A"}} </p>  
                    
                      <ul class="mt-4">
                      <li><span class="ft-wt"> Duration : </span> {{data.fromDate |date}} - {{data.toDate |date}}</li>
                      
                      <li><span class="ft-wt">Description : </span> {{data.description}}</li>
                      </ul>
              
          </div></li> 
      </ul>
  </div>

  <div class="form-group bottom ">
      <a href="javascript:void(0)" routerLink="/projects" class="commonBtn width50 mt-5">Continue</a>
  </div>

</form>
</div>
</section>

<ng-template #addMore>
<div class="modal-body">
<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" (click)="closeModal()">×</span></button>             
<form [formGroup]="form" (ngSubmit)="onSubmit()">
 
<h4 class="pageTitle mb-2"> {{title}} Volunteer experience</h4>
      
 
  <div class="row">
      <div class="col-md-6 col-lg-6 ">
          <div class="form-group">
              <label>Organization<span class="orangeText">*</span> </label>
              <input type="text" class="form-control" placeholder="Child care supervisor" formControlName="organization" maxlength="50"> 
                  <div class="text-danger" *ngIf="form.controls['organization'].hasError('required') && showError">
                    *Please enter organization.
                </div>
          </div>
      </div>
      <div class="col-md-6 col-lg-6 ">
          <div class="form-group">
              <label> Role<span class="orangeText">*</span> </label>
              <input type="text" class="form-control" placeholder="UX Manager" formControlName="role" maxlength="50"> 
                  <div class="text-danger" *ngIf="form.controls['role'].hasError('required') && showError">
                    *Please enter role.
                  </div> 
          </div>
      </div>

      <div class="col-md-6 col-lg-6 ">
          <div class="form-group">
              <label>Cause</label>
              <input type="text" class="form-control" placeholder="UX Manager" formControlName="cause">
              <div class="text-danger" *ngIf="form.controls['cause'].hasError('required') && showError">
                *Please enter cause.
              </div> 
          </div>
      </div>
      <div class="col-md-6 col-lg-6 ">
          <div class=" d-flex justify-content-between">
              <div class="form-group">
                  <label> From </label>
                  <div id="date-picker-example" class="datepicker">
                    <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"  [bsValue]="form.value.fromDate" bsDatepicker placement="bottom" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="fromDate" [maxDate]="maxDate" (keydown)="onKeyDown($event)">
                    <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                </div>
                <div class="text-danger" *ngIf="showError == true && form.controls['fromDate'].hasError('required')">*Please select From</div>
              </div>

              <div class="form-group">
                  <label> To </label>
                  <div id="date-picker-example" class="datepicker">
                    <input type="text" placeholder="Enter date"
                    class="form-control" bsDatepicker
                    [minDate]="form.value.fromDate == '' ? minDate : form.value.fromDate"
                    [maxDate]="maxDate"
                    formControlName="toDate"
                    [bsValue]="form.value.toDate"
                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" (keydown)="onKeyDown($event)">
                    <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                </div>
                <div class="text-danger" *ngIf="showError == true && form.controls['toDate'].hasError('required')">*Please select To</div>
              </div>
          </div>
      </div>
      


      <div class="col-md-12 col-lg-12  col-sm-12">
          <div class="form-group">
              <label> Description </label>
              <textarea type="text" class="form-control" placeholder="As a team lead, a UX manager sets design standards for the team and trains and supports the team in UX best practices." formControlName="description" maxlength="250"></textarea>
              <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                  *Please enter description.
              </div>
              <div class="text-danger" *ngIf="form.controls['description'].hasError('minlength') && showError">
                  *Minimum length of 3 characters.
              </div>
              <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                  *Minimum length of 250 characters.
              </div>
          </div>
      </div>
      <div class="col-md-12 col-lg-12 col-sm-12 ">     
          <h5 class="subTitle2">Employment type</h5>
          <div class="form-group">
            <ul class="suggestedskills">
                <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmployment(i,$event)" [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li> 
            </ul>
          </div>
          </div>
      <div class="col-md-6 col-lg-6 col-sm-12">
          <div class="form-group mt-2">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isCurrentlyRole" [value]="1" [checked]="form.value.isCurrentlyRole == 1" (change)="form.value.isCurrentlyRole=1;isDisabled($event)">
                <label class="custom-control-label" for="customCheckBox1"> I am currently working in this role</label>
                <div class="text-danger" *ngIf="form.controls['isCurrentlyRole'].hasError('required') && showError">
                    *Please accept select.
                </div>
              </div>
          </div>
      </div>
  </div>

  <div class="form-group ">
    <input type="submit" value="Save"  class="commonBtn width50 mt-4"> 
  </div>

</form>
</div>
</ng-template>